import React from "react";
import WithAuth from "./WithAuth";
import { pipe } from "ramda";

const all = pipe(WithAuth);

const Hocs: React.FC = ({ children }) => <div>{children}</div>;

export default all(Hocs);
